<template>
  <div class="hc-textlegend">
    <div
      class="hc-textlegend-legend"
      v-for="d in data"
      :key="d.name"
    >
      <svg :style="style" class="hc-textlegend-hexagon">
        <g :transform="transform">
          <hexagon :fill="d.color" :stroke="d.color"/>
        </g>
      </svg>
      <span>
        {{d.name}}
      </span>
    </div>
  </div>
</template>

<script>
import Hexagon from '../shapes/Hexagon'
export default {
  name: 'TextLegend',
  components: {
    Hexagon
  },
  props: {
    size: {
      type: Number,
      default: 16
    },
    data: {
      type: Array,
      default () { return []}
    }
  },
  data () {
    return {
      Size: this.size
    }
  },
  mounted () {
    this.resize()
    window.addEventListener('resize', this.resize)
  },
  methods: {
    resize () {
      this.Size = this.$el.offsetHeight
    }
  },
  computed: {
    scale () {
      return this.Size / 16
    },
    style () {
      return { height: `${this.Size * this.scale}px`, width: `${this.Size * this.scale}px` }
    },
    transform () {
      return `translate(${this.Size * this.scale / 2}, ${this.Size * this.scale/ 2}) scale(${this.scale / 2})`
    }
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.resize)
  }
}
</script>

<style>

</style>
